import Backbone from 'backbone'
import FormView from 'scoreboard/components/form-view'
import RestConnectionWizardView from 'scoreboard/admin/connections/rest/rest-connection-wizard-view'
import template from 'scoreboard/admin/connections/rest/rest-connection-base-url.hbs'
import urlValidator from 'scoreboard/components/validators/url-validator'
import MarkedField from 'scoreboard/components/marked-field'
import inputLengthValidatorFactory
	from 'scoreboard/components/validators/input-length-validator-factory'
import WsConstants from 'scoreboard/admin/model/ws-constants'
const { 
	ACCESS_TOKEN_PLACEHOLDER, ACCESS_TOKEN_STRATEGY, ACCESS_TOKEN_URL_PARAMETER,
	AUTHORIZATION_HEADER, BASE_URL_MAX_LENGTH, REFRESH_TOKEN_PLACEHOLDER,
	TOKEN_TYPE_PLACEHOLDER
 } = WsConstants
import formHelper from 'scoreboard/components/form-helper'
import _ from 'lodash'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import i18n from 'scoreboard/components/i18n'
import HttpRequestForm from 'scoreboard/components/http-request-form'
import WsAuthenticationType from 'scoreboard/admin/model/ws-authentication-type'
const {OAUTH_V2} = WsAuthenticationType
import {getHttpHeadersAsKeyValuePairs} from 'scoreboard/components/http-utils'

const RestConnectionBaseUrl = Backbone.View.extend({

	tagName: 'form',

	/**
	 * Second step in the rest-connection-wizard, where the user specifies the API's
	 * base URL
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Connection} options.model
	 *
	 * @param {Wizard} options.wizard the current wizard
	 */
	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		RestConnectionWizardView.prototype.render.apply(this, arguments)
		this.$('.dialog-body').replaceWith(template(this.context()))
		formHelper.writeToDom(this.model, this.el)
		this.renderAccessTokenStrategyToggle()
		this.markRequiredFields()
		this.renderHttpRequestHeaders()
		this.renderUrlParameters()
		this.renderRequestBody()
		this.update()
		return this
	},

	context: function() {
		const attrs = this.model.attributes
		const isOauth = attrs.wsAuthenticationType === OAUTH_V2
		const context = {
			isOauth,
		}
		if (!isOauth) return context

		const firstSentenceMsgCode = _.isNil(attrs.refreshToken) ?
			'admin.importConnections.web-service.rest.baseUrl.explanation1.accessToken' :
			'admin.importConnections.web-service.rest.baseUrl.explanation1.refreshToken'
		context.oauthMessage =
			i18n.get('admin.importConnections.web-service.rest.baseUrl.explanation1',
				firstSentenceMsgCode)
		return context
	},

	renderAccessTokenStrategyToggle: function() {
		const attrs = this.model.attributes
		let accessTokenStrategy = ACCESS_TOKEN_STRATEGY.HEADER
		if (!_.isNil(attrs.accessTokenUrlParameters)) {
			accessTokenStrategy = ACCESS_TOKEN_STRATEGY.URL_PARAMETER
		} else if (!_.isNil(attrs.accessTokenRequestBody)) {
			accessTokenStrategy = ACCESS_TOKEN_STRATEGY.REQUEST_BODY
		}

		this.accessTokenStrategyToggle = new LabeledToggle({
			name: 'accessTokenStrategy',
			value: accessTokenStrategy,
			options: [
				{
					label: i18n.get('admin.import.datasource.from.rest.requestHeader'),
					value: ACCESS_TOKEN_STRATEGY.HEADER
				},
				{
					label: i18n.get('admin.import.datasource.from.rest.urlParameter'),
					value: ACCESS_TOKEN_STRATEGY.URL_PARAMETER
				},
				{
					label: i18n.get('admin.import.datasource.from.rest.requestBody'),
					value: ACCESS_TOKEN_STRATEGY.REQUEST_BODY
				},
			],
		})
		this.accessTokenStrategyToggle.on('change', () => this.update())
		this.$('.access-token-strategy .toggle-container').append(this.accessTokenStrategyToggle.el)
		this.accessTokenStrategyToggle.render()
	},

	update: function() {
		this.saveState()
		this.toggle()
		const isOauth = this.model.attributes.wsAuthenticationType === OAUTH_V2

		this.$('.oauth-access-token-strategy-section').toggleClass('is-not-displayed', !isOauth)
		this.$el.toggleClass('oauth-access-token-strategy-dialog', isOauth)
	},

	toggle: function() {
		const accessTokenStrategy = this.accessTokenStrategyToggle.val()

		const isHttpRequestHeadersStrategy = accessTokenStrategy === ACCESS_TOKEN_STRATEGY.HEADER
		this.$('.http-request-headers').toggleClass('is-not-displayed', !isHttpRequestHeadersStrategy)

		const isUrlParametersStrategy = accessTokenStrategy === ACCESS_TOKEN_STRATEGY.URL_PARAMETER
		this.$('.url-parameters').toggleClass('is-not-displayed', !isUrlParametersStrategy)

		const isRequestBodyStrategy = accessTokenStrategy === ACCESS_TOKEN_STRATEGY.REQUEST_BODY
		this.$('.request-body').toggleClass('is-not-displayed', !isRequestBodyStrategy)
	},

	getHttpHeaderItemData: function() {
		const attrs = this.model.attributes
		return getHttpHeadersAsKeyValuePairs(attrs.accessTokenHttpHeaders)
	},

	renderHttpRequestHeaders: function() {
		this.httpRequestHeadersList && this.httpRequestHeadersList.remove()

		HttpRequestForm.prototype.renderHttpRequestHeaders.apply(this, arguments)
		const attrs = this.model.attributes
		// if we don't already have headers, then initialize the input with a default
		// Authorization header
		if (_.isNil(attrs.accessTokenHttpHeaders)) {
			this.initializeDefaultValuesForConfigurableList(
				this.httpRequestHeadersList,
				AUTHORIZATION_HEADER,
				`${TOKEN_TYPE_PLACEHOLDER} ${ACCESS_TOKEN_PLACEHOLDER}`)
		}
		// only one header is allowed
		this.httpRequestHeadersList.$('.add-list-item').addClass('is-not-displayed')
	},

	renderUrlParameters: function() {
		this.urlParametersList && this.urlParametersList.remove()

		const attrs = this.model.attributes
		HttpRequestForm.prototype.renderUrlParameters.apply(this, [attrs.accessTokenUrlParameters])
		// if we don't already have url params, then initialize the input with a default
		// access_token param
		if (_.isNil(attrs.accessTokenUrlParameters)) {
			this.initializeDefaultValuesForConfigurableList(
				this.urlParametersList, ACCESS_TOKEN_URL_PARAMETER,
				ACCESS_TOKEN_PLACEHOLDER)
		}
		// only one url parameter is allowed
		this.urlParametersList.$('.add-list-item').addClass('is-not-displayed')
	},

	initializeDefaultValuesForConfigurableList: function(configurableList, key, value) {
		// add an empty item
		configurableList.$('.add-list-item').trigger('click')
		configurableList.$('[name=key]').val(key)
		configurableList.$('[name=value]').val(value)
	},

	createConfigurableList: function({ containerEl, itemData, addLabel }) {
		const list = HttpRequestForm.prototype.createConfigurableList.apply(this, arguments)
		list.options.allowLastItemDeletion = false
		list.allowLastItemDeletion = false
		return list
	},

	renderRequestBody: function() {
		const attrs = this.model.attributes
		const requestBodyTextarea = this.$('[name=requestBody]')
		if (_.isNil(attrs.accessTokenRequestBody)) {
			requestBodyTextarea.val(`
				${ACCESS_TOKEN_PLACEHOLDER}
				${REFRESH_TOKEN_PLACEHOLDER}
			`)
		} else {
			requestBodyTextarea.val(attrs.accessTokenRequestBody)
		}
	},

	markRequiredFields: function() {
		let baseUrlLenValidator = inputLengthValidatorFactory({ high: BASE_URL_MAX_LENGTH })
		this.requiredFields = [
			new MarkedField({
				el: this.$('[name=baseUrl]'),
				validators: [urlValidator, baseUrlLenValidator]
			}).render()
		]
	},

	readFromDom: function() {
		const fromDom = HttpRequestForm.prototype.readFromDom.apply(this, arguments)
		fromDom.baseUrl = _.trim(fromDom.baseUrl)
		fromDom.accessTokenUrlParameters = fromDom.urlParameters
		delete fromDom.urlParameters
		fromDom.accessTokenHttpHeaders = fromDom.httpRequestHeaders
		delete fromDom.httpRequestHeaders
		fromDom.accessTokenRequestBody = fromDom.requestBody
		delete fromDom.requestBody
		delete fromDom.accessTokenStrategy
		return fromDom
	},

	saveState: function() {
		_.extend(this.model.attributes, this.readFromDom())
	},

	submit: function() {
		this.saveState()

		// delete unused attributes based on the current access token strategy
		const accessTokenStrategy = this.accessTokenStrategyToggle.val()
		if (accessTokenStrategy === ACCESS_TOKEN_STRATEGY.HEADER) {
			delete this.model.attributes.accessTokenUrlParameters
			delete this.model.attributes.accessTokenRequestBody
		}
		if (accessTokenStrategy === ACCESS_TOKEN_STRATEGY.URL_PARAMETER) {
			delete this.model.attributes.accessTokenHttpHeaders
			delete this.model.attributes.accessTokenRequestBody
		}
		if (accessTokenStrategy === ACCESS_TOKEN_STRATEGY.REQUEST_BODY) {
			delete this.model.attributes.accessTokenHttpHeaders
			delete this.model.attributes.accessTokenUrlParameters
		}

		this.options.wizard.next()
	},
})

export default RestConnectionBaseUrl
RestConnectionBaseUrl.__filename__ = 'admin/connections/rest/rest-connection-base-url.js'
